/** Map Firebase callable / Functions errors to short user-facing messages. */
export function callableErrorMessage(error: unknown): string {
  const raw =
    typeof error === 'object' && error && 'message' in error
      ? String((error as { message: string }).message)
      : error instanceof Error
        ? error.message
        : 'Something went wrong'

  const cleaned = raw.replace(/^Firebase:\s*/i, '').replace(/^FirebaseError:\s*/i, '')
  const codeMatch = cleaned.match(/^[A-Z][A-Z0-9_]+:\s*(.+)$/)
  if (codeMatch?.[1]) return codeMatch[1]

  const parenMatch = cleaned.match(/\(([^)]+)\)\s*$/)
  if (parenMatch?.[1]?.startsWith('functions/')) {
    const withoutParen = cleaned.replace(/\s*\([^)]+\)\s*$/, '').trim()
    if (withoutParen) return withoutParen
  }

  return cleaned || 'Something went wrong'
}
